import {UserSessionReq} from "./user-session-req-interface";
import {
    EventoProyectoReq,
    EventoUsuarioReq
} from "../../officials/inspecciones/components/interfaces/evento-asignacion-interface";

export interface PersonaInfo {
    idPersona: string;
    uniqueId: string;
    nombres: string;
    apellidos: string;
    direccion: null;
    verificada: number;
    contactos: Contacto[];
    documentos: Documento[];
    idTipoPersona?: number | null;
    tipoPersona?: string | null;
    clasificacion?: Clasificacion;
    profesion?:Profesion
}

export interface Contacto {
    idContacto: number;
    tipo: string;
    contacto: string;
    mascara?: string;
    verificado: number;
}

export interface Documento {
    idDocumento: number;
    tipo: string;
    documento: string;
    principal: number;
}

export interface CalendarEvent {
    eventId: string;             // Corresponds to event_id in the database
    groupId?: string;            // Corresponds to group_id in the database
    title?: string;               // Corresponds to title in the database
    description?: string;        // Corresponds to description in the database
    startDate?: string | null | Date;           // Corresponds to start_date in the database (ISO string)
    endDate?: string | null | Date;            // Corresponds to end_date in the database (ISO string)
    allDay?: boolean;            // Corresponds to all_day in the database (true/false)
    backgroundColor?: string;    // Corresponds to background_color in the database
    textColor?: string;          // Corresponds to text_color in the database
    url?: string;                // Corresponds to url in the database
    status?: string;  // Corresponds to status in the database
    idStatus?: number;
    types?: string;
    idType?: number;
    createdAt?: string;          // Corresponds to created_at in the database (ISO string)
    updatedAt?: string;          // Corresponds to updated_at in the database (ISO string)
    approvedAt?: string;
    uniqueIdProcesa?: string;
    uniqueIdAprueba?: string;
    creadoPor?: string;
    session?: UserSessionReq;
    usuarios?: EventoUsuarioReq;
    proyectos?: EventoProyectoReq;
}

export interface EventoUsuarioRes {
    idEvento: string;
    uniqueIdsUsuarios: string[];
}

export interface FrmPasoItem {
    id: string;
    idFormulario: string;
    label: string;
    icon?: string;
    orden: number;
    estado: boolean;
}

export interface SolicitudRequisitoItem {
    idSolicitud: string | number;  // Type BigInteger can be represented by string or number in TypeScript
    idProyecto: string | number;   // Same for BigInteger
    idRequisito: string | number;  // Same for BigInteger
    value: string;
    session: UserSessionReq;       // Assuming you have a UserSessionReq interface defined elsewhere
}

export enum TipoAutorizaciones {
    Titular = 1,
    Profesional = 2,
    Persona = 3
}

export interface Clasificacion {
    idClasificacion: number;
    clasificacion: string;
}
export interface Profesion {
    idProfesion: number;
    profesion: string;
}
